package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * San Marino Flag (20x15dp)
 *
 * - ISO Alpha-2: SM
 * - ISO Alpha-3: SMR
 * - ISO Numeric: 674
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.SanMarino: ImageVector by lazy {
    ImageVector.Builder(
        name = "San Marino:SM:SMR:674:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF56C6F5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 7.5f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(7.5f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF006923)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.409f, 5.643f)
                curveTo(6.404f, 5.59f, 6.393f, 5.544f, 6.374f, 5.509f)
                curveTo(6.214f, 5.21f, 6.265f, 4.835f, 6.265f, 4.835f)
                curveTo(6.265f, 4.835f, 6.074f, 5.274f, 5.961f, 5.686f)
                curveTo(5.843f, 5.494f, 5.802f, 5.302f, 5.802f, 5.302f)
                curveTo(5.802f, 5.302f, 5.725f, 6.513f, 5.959f, 6.799f)
                curveTo(6.193f, 7.086f, 6.349f, 7.213f, 6.349f, 7.213f)
                curveTo(6.349f, 7.213f, 6.367f, 6.71f, 6.299f, 6.316f)
                curveTo(6.347f, 6.152f, 6.39f, 5.973f, 6.405f, 5.818f)
                curveTo(6.436f, 5.795f, 6.517f, 5.734f, 6.618f, 5.652f)
                curveTo(6.576f, 5.887f, 6.574f, 6.015f, 6.574f, 6.015f)
                curveTo(6.574f, 6.015f, 7.455f, 5.375f, 7.478f, 5.036f)
                curveTo(7.5f, 4.697f, 7.742f, 4.407f, 7.742f, 4.407f)
                curveTo(7.742f, 4.407f, 7.542f, 4.545f, 7.313f, 4.728f)
                curveTo(7.374f, 4.444f, 7.561f, 4.22f, 7.561f, 4.22f)
                curveTo(7.561f, 4.22f, 6.56f, 4.905f, 6.477f, 5.266f)
                curveTo(6.442f, 5.423f, 6.421f, 5.55f, 6.409f, 5.643f)
                close()
                moveTo(6.452f, 7.724f)
                curveTo(6.356f, 7.543f, 5.938f, 6.783f, 5.646f, 6.717f)
                curveTo(5.315f, 6.642f, 5.067f, 6.357f, 5.067f, 6.357f)
                curveTo(5.067f, 6.357f, 5.587f, 7.453f, 5.931f, 7.591f)
                curveTo(6.207f, 7.701f, 6.388f, 7.745f, 6.449f, 7.758f)
                curveTo(6.439f, 7.906f, 6.438f, 8.008f, 6.438f, 8.008f)
                curveTo(6.438f, 8.008f, 6.6f, 7.891f, 6.849f, 7.616f)
                curveTo(7.097f, 7.342f, 7.084f, 6.129f, 7.084f, 6.129f)
                curveTo(7.084f, 6.129f, 6.986f, 6.494f, 6.721f, 6.706f)
                curveTo(6.543f, 6.849f, 6.477f, 7.386f, 6.452f, 7.724f)
                close()
                moveTo(5.67f, 7.61f)
                curveTo(6.048f, 7.607f, 6.63f, 8.535f, 6.63f, 8.535f)
                curveTo(6.63f, 8.535f, 6.404f, 8.547f, 6.011f, 8.485f)
                curveTo(5.617f, 8.423f, 5.003f, 7.366f, 5.003f, 7.366f)
                curveTo(5.003f, 7.366f, 5.291f, 7.612f, 5.67f, 7.61f)
                close()
                moveTo(7.514f, 9.77f)
                curveTo(7.514f, 9.77f, 7.738f, 8.588f, 7.401f, 8.312f)
                curveTo(7.064f, 8.037f, 7.005f, 7.625f, 7.005f, 7.625f)
                curveTo(7.005f, 7.625f, 6.705f, 8.936f, 7.005f, 9.275f)
                curveTo(7.304f, 9.615f, 7.514f, 9.77f, 7.514f, 9.77f)
                close()
                moveTo(6.154f, 9.451f)
                curveTo(6.374f, 9.712f, 7.075f, 9.451f, 7.075f, 9.451f)
                curveTo(7.075f, 9.451f, 7.23f, 9.591f, 6.673f, 9.083f)
                curveTo(6.117f, 8.575f, 4.985f, 8.896f, 5.29f, 8.896f)
                curveTo(5.595f, 8.896f, 5.933f, 9.19f, 6.154f, 9.451f)
                close()
                moveTo(6.673f, 10.839f)
                curveTo(7.081f, 11.184f, 7.963f, 10.363f, 7.963f, 10.363f)
                curveTo(7.963f, 10.363f, 7.736f, 10.088f, 7.316f, 9.885f)
                curveTo(6.895f, 9.682f, 5.343f, 9.885f, 5.343f, 9.885f)
                lineTo(6.034f, 10.193f)
                curveTo(6.034f, 10.193f, 5.265f, 10.493f, 5.469f, 10.476f)
                curveTo(5.673f, 10.46f, 6.265f, 10.493f, 6.673f, 10.839f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF009933)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.008f, 10.123f)
                curveTo(12.008f, 10.123f, 11.658f, 9.533f, 12.008f, 9.248f)
                curveTo(12.359f, 8.963f, 12.498f, 9.153f, 12.498f, 8.825f)
                curveTo(12.498f, 8.498f, 12.534f, 8.595f, 12.706f, 8.433f)
                curveTo(12.878f, 8.27f, 12.756f, 7.875f, 12.987f, 8.073f)
                curveTo(13.218f, 8.27f, 13.261f, 7.892f, 13.261f, 8.678f)
                curveTo(13.261f, 9.465f, 13.261f, 7.965f, 13.261f, 7.523f)
                curveTo(13.261f, 7.081f, 12.987f, 7.186f, 12.987f, 6.89f)
                curveTo(12.987f, 6.593f, 12.713f, 6.151f, 12.987f, 6.151f)
                curveTo(13.261f, 6.151f, 13.422f, 6.48f, 13.422f, 6.48f)
                curveTo(13.422f, 6.48f, 13.691f, 6.939f, 13.691f, 6.48f)
                curveTo(13.691f, 6.021f, 13.212f, 6.158f, 12.987f, 5.651f)
                curveTo(12.762f, 5.145f, 12.798f, 5.708f, 12.498f, 5.056f)
                curveTo(12.198f, 4.403f, 11.842f, 4.196f, 12.17f, 4.196f)
                curveTo(12.498f, 4.196f, 12.425f, 4.196f, 12.706f, 4.196f)
                curveTo(12.987f, 4.196f, 13.422f, 3.963f, 13.422f, 4.196f)
                curveTo(13.422f, 4.43f, 13.422f, 4.323f, 13.422f, 4.689f)
                curveTo(13.422f, 5.056f, 13.691f, 5.056f, 13.691f, 5.056f)
                curveTo(13.691f, 5.056f, 13.838f, 4.323f, 14.022f, 4.689f)
                curveTo(14.205f, 5.056f, 14.08f, 5.651f, 14.215f, 5.651f)
                curveTo(14.349f, 5.651f, 14.238f, 5.036f, 14.532f, 5.507f)
                curveTo(14.826f, 5.979f, 14.532f, 6.298f, 14.532f, 6.48f)
                curveTo(14.532f, 6.662f, 14.215f, 7.108f, 14.215f, 7.108f)
                curveTo(14.215f, 7.108f, 14.277f, 7.325f, 14.532f, 7.108f)
                curveTo(14.787f, 6.89f, 15.029f, 6.672f, 15.029f, 6.89f)
                curveTo(15.029f, 7.108f, 15.526f, 7.175f, 15.029f, 7.523f)
                curveTo(14.532f, 7.871f, 14.849f, 8.219f, 14.532f, 8.219f)
                curveTo(14.215f, 8.219f, 13.841f, 8.678f, 13.691f, 8.678f)
                curveTo(13.542f, 8.678f, 12.981f, 9.03f, 13.261f, 9.03f)
                curveTo(13.542f, 9.03f, 13.828f, 8.327f, 14.022f, 8.678f)
                curveTo(14.215f, 9.03f, 14.212f, 8.621f, 14.372f, 8.825f)
                curveTo(14.532f, 9.03f, 14.692f, 10.138f, 14.532f, 9.693f)
                curveTo(14.372f, 9.248f, 14.122f, 9.248f, 13.691f, 9.248f)
                curveTo(13.261f, 9.248f, 12.425f, 9.28f, 12.706f, 9.487f)
                curveTo(12.987f, 9.693f, 13.303f, 9.28f, 13.422f, 9.487f)
                curveTo(13.542f, 9.693f, 13.507f, 9.9f, 13.691f, 9.693f)
                curveTo(13.876f, 9.487f, 14.058f, 9.693f, 14.215f, 9.693f)
                curveTo(14.372f, 9.693f, 14.058f, 9.924f, 14.215f, 10.123f)
                curveTo(14.372f, 10.321f, 14.722f, 10.585f, 14.372f, 10.585f)
                curveTo(14.022f, 10.585f, 13.841f, 10.305f, 13.691f, 10.585f)
                curveTo(13.542f, 10.866f, 13.535f, 11.352f, 13.261f, 10.969f)
                curveTo(12.987f, 10.585f, 12.498f, 10.78f, 12.498f, 10.585f)
                curveTo(12.498f, 10.391f, 12.605f, 10.359f, 12.307f, 10.359f)
                curveTo(12.008f, 10.359f, 12.008f, 10.123f, 12.008f, 10.123f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(13.448f, 5.906f)
                curveTo(13.448f, 5.993f, 13.38f, 6.063f, 13.296f, 6.063f)
                curveTo(13.213f, 6.063f, 13.145f, 5.993f, 13.145f, 5.906f)
                curveTo(13.145f, 5.82f, 13.213f, 5.75f, 13.296f, 5.75f)
                curveTo(13.38f, 5.75f, 13.448f, 5.82f, 13.448f, 5.906f)
                close()
                moveTo(6.462f, 6.25f)
                curveTo(6.545f, 6.25f, 6.613f, 6.18f, 6.613f, 6.094f)
                curveTo(6.613f, 6.007f, 6.545f, 5.938f, 6.462f, 5.938f)
                curveTo(6.378f, 5.938f, 6.31f, 6.007f, 6.31f, 6.094f)
                curveTo(6.31f, 6.18f, 6.378f, 6.25f, 6.462f, 6.25f)
                close()
                moveTo(6.613f, 6.906f)
                curveTo(6.613f, 6.993f, 6.545f, 7.063f, 6.462f, 7.063f)
                curveTo(6.378f, 7.063f, 6.31f, 6.993f, 6.31f, 6.906f)
                curveTo(6.31f, 6.82f, 6.378f, 6.75f, 6.462f, 6.75f)
                curveTo(6.545f, 6.75f, 6.613f, 6.82f, 6.613f, 6.906f)
                close()
                moveTo(6.704f, 8.5f)
                curveTo(6.787f, 8.5f, 6.855f, 8.43f, 6.855f, 8.344f)
                curveTo(6.855f, 8.257f, 6.787f, 8.188f, 6.704f, 8.188f)
                curveTo(6.62f, 8.188f, 6.552f, 8.257f, 6.552f, 8.344f)
                curveTo(6.552f, 8.43f, 6.62f, 8.5f, 6.704f, 8.5f)
                close()
                moveTo(7.913f, 10.063f)
                curveTo(7.997f, 10.063f, 8.065f, 9.993f, 8.065f, 9.906f)
                curveTo(8.065f, 9.82f, 7.997f, 9.75f, 7.913f, 9.75f)
                curveTo(7.83f, 9.75f, 7.762f, 9.82f, 7.762f, 9.906f)
                curveTo(7.762f, 9.993f, 7.83f, 10.063f, 7.913f, 10.063f)
                close()
                moveTo(13.72f, 7.688f)
                curveTo(13.803f, 7.688f, 13.871f, 7.618f, 13.871f, 7.531f)
                curveTo(13.871f, 7.445f, 13.803f, 7.375f, 13.72f, 7.375f)
                curveTo(13.636f, 7.375f, 13.568f, 7.445f, 13.568f, 7.531f)
                curveTo(13.568f, 7.618f, 13.636f, 7.688f, 13.72f, 7.688f)
                close()
                moveTo(13.387f, 8.781f)
                curveTo(13.387f, 8.868f, 13.319f, 8.938f, 13.236f, 8.938f)
                curveTo(13.152f, 8.938f, 13.085f, 8.868f, 13.085f, 8.781f)
                curveTo(13.085f, 8.695f, 13.152f, 8.625f, 13.236f, 8.625f)
                curveTo(13.319f, 8.625f, 13.387f, 8.695f, 13.387f, 8.781f)
                close()
                moveTo(11.966f, 10.313f)
                curveTo(12.049f, 10.313f, 12.117f, 10.243f, 12.117f, 10.156f)
                curveTo(12.117f, 10.07f, 12.049f, 10f, 11.966f, 10f)
                curveTo(11.882f, 10f, 11.814f, 10.07f, 11.814f, 10.156f)
                curveTo(11.814f, 10.243f, 11.882f, 10.313f, 11.966f, 10.313f)
                close()
                moveTo(8.125f, 10.344f)
                curveTo(8.125f, 10.43f, 8.057f, 10.5f, 7.974f, 10.5f)
                curveTo(7.89f, 10.5f, 7.823f, 10.43f, 7.823f, 10.344f)
                curveTo(7.823f, 10.257f, 7.89f, 10.188f, 7.974f, 10.188f)
                curveTo(8.057f, 10.188f, 8.125f, 10.257f, 8.125f, 10.344f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.274f, 12.387f)
                curveTo(11.274f, 12.259f, 9.336f, 10.924f, 8.816f, 10.629f)
                curveTo(8.296f, 10.335f, 5.756f, 8.714f, 6.447f, 6.25f)
                horizontalLineTo(6.343f)
                curveTo(6.343f, 6.25f, 5.875f, 9.285f, 9.1f, 11.172f)
                curveTo(10.568f, 12.157f, 10.641f, 12.387f, 10.641f, 12.387f)
                curveTo(10.641f, 12.387f, 11.274f, 12.516f, 11.274f, 12.387f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.703f, 12.387f)
                curveTo(8.703f, 12.259f, 10.641f, 10.924f, 11.161f, 10.629f)
                curveTo(11.681f, 10.335f, 14.221f, 8.714f, 13.529f, 6.25f)
                horizontalLineTo(13.634f)
                curveTo(13.634f, 6.25f, 14.102f, 9.285f, 10.877f, 11.172f)
                curveTo(9.408f, 12.157f, 9.335f, 12.387f, 9.335f, 12.387f)
                curveTo(9.335f, 12.387f, 8.703f, 12.516f, 8.703f, 12.387f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF56C6F5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.03f, 10.554f)
                curveTo(11.383f, 10.554f, 12.48f, 8.802f, 12.48f, 7.094f)
                curveTo(12.48f, 5.385f, 11.383f, 4.5f, 10.03f, 4.5f)
                curveTo(8.677f, 4.5f, 7.581f, 5.385f, 7.581f, 7.094f)
                curveTo(7.581f, 8.802f, 8.677f, 10.554f, 10.03f, 10.554f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.946f, 5.962f)
                curveTo(8.946f, 5.962f, 9.323f, 5.629f, 9.134f, 5.629f)
                curveTo(9.098f, 5.629f, 9.053f, 5.622f, 9.005f, 5.614f)
                curveTo(8.806f, 5.582f, 8.546f, 5.54f, 8.546f, 5.962f)
                verticalLineTo(6.686f)
                lineTo(8.546f, 6.687f)
                horizontalLineTo(8.49f)
                curveTo(8.455f, 6.687f, 8.427f, 6.715f, 8.427f, 6.75f)
                curveTo(8.427f, 6.785f, 8.455f, 6.812f, 8.49f, 6.812f)
                horizontalLineTo(8.539f)
                curveTo(8.53f, 6.967f, 8.516f, 7.242f, 8.501f, 7.517f)
                lineTo(8.43f, 7.523f)
                curveTo(8.393f, 7.527f, 8.365f, 7.559f, 8.369f, 7.596f)
                lineTo(8.373f, 7.649f)
                curveTo(8.376f, 7.686f, 8.409f, 7.713f, 8.446f, 7.71f)
                lineTo(8.491f, 7.706f)
                curveTo(8.474f, 8.027f, 8.46f, 8.308f, 8.46f, 8.343f)
                curveTo(8.46f, 8.427f, 9.034f, 8.394f, 9.034f, 8.394f)
                curveTo(9.034f, 8.394f, 9.016f, 8.056f, 8.997f, 7.662f)
                lineTo(9.035f, 7.659f)
                curveTo(9.072f, 7.655f, 9.099f, 7.623f, 9.096f, 7.586f)
                lineTo(9.092f, 7.533f)
                curveTo(9.088f, 7.496f, 9.056f, 7.469f, 9.019f, 7.472f)
                lineTo(8.987f, 7.474f)
                curveTo(8.976f, 7.239f, 8.964f, 6.999f, 8.957f, 6.812f)
                horizontalLineTo(9.03f)
                curveTo(9.065f, 6.812f, 9.093f, 6.785f, 9.093f, 6.75f)
                curveTo(9.093f, 6.715f, 9.065f, 6.687f, 9.03f, 6.687f)
                horizontalLineTo(8.951f)
                curveTo(8.948f, 6.594f, 8.946f, 6.524f, 8.946f, 6.489f)
                verticalLineTo(5.962f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.669f, 6.875f)
                horizontalLineTo(8.871f)
                verticalLineTo(7.144f)
                horizontalLineTo(8.669f)
                verticalLineTo(6.875f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.609f, 7.813f)
                horizontalLineTo(8.945f)
                verticalLineTo(8.438f)
                horizontalLineTo(8.609f)
                verticalLineTo(7.813f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.216f, 5.962f)
                curveTo(10.216f, 5.962f, 10.593f, 5.629f, 10.405f, 5.629f)
                curveTo(10.368f, 5.629f, 10.323f, 5.622f, 10.275f, 5.614f)
                curveTo(10.076f, 5.582f, 9.816f, 5.54f, 9.816f, 5.962f)
                verticalLineTo(6.686f)
                lineTo(9.816f, 6.687f)
                horizontalLineTo(9.76f)
                curveTo(9.726f, 6.687f, 9.698f, 6.715f, 9.698f, 6.75f)
                curveTo(9.698f, 6.785f, 9.726f, 6.812f, 9.76f, 6.812f)
                horizontalLineTo(9.809f)
                curveTo(9.801f, 6.967f, 9.786f, 7.242f, 9.771f, 7.517f)
                lineTo(9.7f, 7.523f)
                curveTo(9.663f, 7.527f, 9.635f, 7.559f, 9.639f, 7.596f)
                lineTo(9.643f, 7.649f)
                curveTo(9.647f, 7.686f, 9.679f, 7.713f, 9.716f, 7.71f)
                lineTo(9.761f, 7.706f)
                curveTo(9.745f, 8.027f, 9.73f, 8.308f, 9.73f, 8.343f)
                curveTo(9.73f, 8.427f, 10.304f, 8.394f, 10.304f, 8.394f)
                curveTo(10.304f, 8.394f, 10.286f, 8.056f, 10.267f, 7.662f)
                lineTo(10.305f, 7.659f)
                curveTo(10.342f, 7.655f, 10.37f, 7.623f, 10.366f, 7.586f)
                lineTo(10.362f, 7.533f)
                curveTo(10.358f, 7.496f, 10.326f, 7.469f, 10.289f, 7.472f)
                lineTo(10.257f, 7.474f)
                curveTo(10.246f, 7.239f, 10.235f, 6.999f, 10.227f, 6.812f)
                horizontalLineTo(10.3f)
                curveTo(10.335f, 6.812f, 10.363f, 6.785f, 10.363f, 6.75f)
                curveTo(10.363f, 6.715f, 10.335f, 6.687f, 10.3f, 6.687f)
                horizontalLineTo(10.222f)
                curveTo(10.218f, 6.594f, 10.216f, 6.524f, 10.216f, 6.489f)
                verticalLineTo(5.962f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.94f, 6.875f)
                horizontalLineTo(10.141f)
                verticalLineTo(7.144f)
                horizontalLineTo(9.94f)
                verticalLineTo(6.875f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.879f, 7.813f)
                horizontalLineTo(10.215f)
                verticalLineTo(8.438f)
                horizontalLineTo(9.879f)
                verticalLineTo(7.813f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.426f, 5.962f)
                curveTo(11.426f, 5.962f, 11.803f, 5.629f, 11.614f, 5.629f)
                curveTo(11.578f, 5.629f, 11.533f, 5.622f, 11.485f, 5.614f)
                curveTo(11.285f, 5.582f, 11.026f, 5.54f, 11.026f, 5.962f)
                verticalLineTo(6.686f)
                lineTo(11.025f, 6.687f)
                horizontalLineTo(10.97f)
                curveTo(10.935f, 6.687f, 10.907f, 6.715f, 10.907f, 6.75f)
                curveTo(10.907f, 6.785f, 10.935f, 6.812f, 10.97f, 6.812f)
                horizontalLineTo(11.019f)
                curveTo(11.01f, 6.967f, 10.995f, 7.242f, 10.981f, 7.517f)
                lineTo(10.91f, 7.523f)
                curveTo(10.873f, 7.527f, 10.845f, 7.559f, 10.848f, 7.596f)
                lineTo(10.853f, 7.649f)
                curveTo(10.856f, 7.686f, 10.889f, 7.713f, 10.926f, 7.71f)
                lineTo(10.971f, 7.706f)
                curveTo(10.954f, 8.027f, 10.94f, 8.308f, 10.94f, 8.343f)
                curveTo(10.94f, 8.427f, 11.514f, 8.394f, 11.514f, 8.394f)
                curveTo(11.514f, 8.394f, 11.496f, 8.056f, 11.476f, 7.662f)
                lineTo(11.515f, 7.659f)
                curveTo(11.552f, 7.655f, 11.579f, 7.623f, 11.576f, 7.586f)
                lineTo(11.571f, 7.533f)
                curveTo(11.568f, 7.496f, 11.536f, 7.469f, 11.499f, 7.472f)
                lineTo(11.467f, 7.474f)
                curveTo(11.456f, 7.239f, 11.444f, 6.999f, 11.436f, 6.812f)
                horizontalLineTo(11.51f)
                curveTo(11.545f, 6.812f, 11.573f, 6.785f, 11.573f, 6.75f)
                curveTo(11.573f, 6.715f, 11.545f, 6.687f, 11.51f, 6.687f)
                horizontalLineTo(11.431f)
                curveTo(11.428f, 6.594f, 11.426f, 6.524f, 11.426f, 6.489f)
                verticalLineTo(5.962f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.149f, 6.875f)
                horizontalLineTo(11.351f)
                verticalLineTo(7.144f)
                horizontalLineTo(11.149f)
                verticalLineTo(6.875f)
                close()
            }
            path(
                fill = SolidColor(Color.Black),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.089f, 7.813f)
                horizontalLineTo(11.425f)
                verticalLineTo(8.438f)
                horizontalLineTo(11.089f)
                verticalLineTo(7.813f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.573f, 4f)
                horizontalLineTo(8.367f)
                verticalLineTo(4.479f)
                lineTo(8.345f, 4.48f)
                curveTo(8.345f, 4.48f, 6.775f, 5.701f, 7.211f, 7.529f)
                curveTo(7.647f, 9.357f, 9.378f, 10.713f, 9.378f, 10.713f)
                lineTo(9.465f, 10.398f)
                curveTo(9.465f, 10.398f, 7.815f, 8.154f, 7.815f, 7.258f)
                curveTo(7.815f, 6.362f, 8.127f, 5.52f, 8.456f, 5.39f)
                curveTo(8.655f, 5.311f, 8.689f, 5.327f, 8.743f, 5.352f)
                curveTo(8.779f, 5.369f, 8.823f, 5.39f, 8.93f, 5.39f)
                curveTo(9.197f, 5.39f, 9.465f, 5.198f, 9.465f, 5.198f)
                curveTo(9.465f, 5.198f, 9.651f, 5.39f, 9.824f, 5.39f)
                curveTo(9.997f, 5.39f, 10f, 5.198f, 10f, 5.198f)
                verticalLineTo(4.563f)
                horizontalLineTo(10.019f)
                verticalLineTo(5.198f)
                curveTo(10.019f, 5.198f, 10.022f, 5.39f, 10.195f, 5.39f)
                curveTo(10.368f, 5.39f, 10.554f, 5.198f, 10.554f, 5.198f)
                curveTo(10.554f, 5.198f, 10.822f, 5.39f, 11.09f, 5.39f)
                curveTo(11.196f, 5.39f, 11.241f, 5.369f, 11.276f, 5.352f)
                curveTo(11.33f, 5.327f, 11.365f, 5.311f, 11.563f, 5.39f)
                curveTo(11.892f, 5.52f, 12.204f, 6.362f, 12.204f, 7.258f)
                curveTo(12.204f, 8.154f, 10.554f, 10.398f, 10.554f, 10.398f)
                lineTo(10.641f, 10.713f)
                curveTo(10.641f, 10.713f, 12.373f, 9.357f, 12.808f, 7.529f)
                curveTo(13.244f, 5.701f, 11.674f, 4.48f, 11.674f, 4.48f)
                lineTo(11.573f, 4.471f)
                verticalLineTo(4f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(8.367f, 4f)
                verticalLineTo(3.688f)
                horizontalLineTo(8.054f)
                verticalLineTo(4f)
                horizontalLineTo(8.367f)
                close()
                moveTo(11.573f, 4f)
                horizontalLineTo(11.885f)
                verticalLineTo(3.688f)
                horizontalLineTo(11.573f)
                verticalLineTo(4f)
                close()
                moveTo(8.367f, 4.479f)
                lineTo(8.395f, 4.79f)
                lineTo(8.679f, 4.764f)
                verticalLineTo(4.479f)
                horizontalLineTo(8.367f)
                close()
                moveTo(8.345f, 4.48f)
                lineTo(8.318f, 4.169f)
                lineTo(8.226f, 4.177f)
                lineTo(8.154f, 4.234f)
                lineTo(8.345f, 4.48f)
                close()
                moveTo(7.211f, 7.529f)
                lineTo(7.515f, 7.457f)
                lineTo(7.211f, 7.529f)
                close()
                moveTo(9.378f, 10.713f)
                lineTo(9.185f, 10.959f)
                lineTo(9.554f, 11.248f)
                lineTo(9.679f, 10.797f)
                lineTo(9.378f, 10.713f)
                close()
                moveTo(9.465f, 10.398f)
                lineTo(9.766f, 10.481f)
                lineTo(9.807f, 10.335f)
                lineTo(9.717f, 10.212f)
                lineTo(9.465f, 10.398f)
                close()
                moveTo(8.456f, 5.39f)
                lineTo(8.572f, 5.68f)
                lineTo(8.456f, 5.39f)
                close()
                moveTo(8.743f, 5.352f)
                lineTo(8.875f, 5.069f)
                lineTo(8.875f, 5.069f)
                lineTo(8.743f, 5.352f)
                close()
                moveTo(9.465f, 5.198f)
                lineTo(9.689f, 4.98f)
                lineTo(9.502f, 4.787f)
                lineTo(9.283f, 4.944f)
                lineTo(9.465f, 5.198f)
                close()
                moveTo(10f, 5.198f)
                lineTo(10.312f, 5.202f)
                verticalLineTo(5.198f)
                horizontalLineTo(10f)
                close()
                moveTo(10f, 4.563f)
                verticalLineTo(4.25f)
                horizontalLineTo(9.687f)
                verticalLineTo(4.563f)
                horizontalLineTo(10f)
                close()
                moveTo(10.019f, 4.563f)
                horizontalLineTo(10.332f)
                verticalLineTo(4.25f)
                horizontalLineTo(10.019f)
                verticalLineTo(4.563f)
                close()
                moveTo(10.019f, 5.198f)
                horizontalLineTo(9.707f)
                lineTo(9.707f, 5.202f)
                lineTo(10.019f, 5.198f)
                close()
                moveTo(10.554f, 5.198f)
                lineTo(10.736f, 4.944f)
                lineTo(10.517f, 4.787f)
                lineTo(10.33f, 4.98f)
                lineTo(10.554f, 5.198f)
                close()
                moveTo(11.276f, 5.352f)
                lineTo(11.144f, 5.069f)
                lineTo(11.144f, 5.069f)
                lineTo(11.276f, 5.352f)
                close()
                moveTo(11.563f, 5.39f)
                lineTo(11.448f, 5.68f)
                lineTo(11.563f, 5.39f)
                close()
                moveTo(10.554f, 10.398f)
                lineTo(10.302f, 10.212f)
                lineTo(10.212f, 10.335f)
                lineTo(10.253f, 10.481f)
                lineTo(10.554f, 10.398f)
                close()
                moveTo(10.641f, 10.713f)
                lineTo(10.34f, 10.797f)
                lineTo(10.465f, 11.248f)
                lineTo(10.834f, 10.959f)
                lineTo(10.641f, 10.713f)
                close()
                moveTo(12.808f, 7.529f)
                lineTo(13.112f, 7.602f)
                lineTo(12.808f, 7.529f)
                close()
                moveTo(11.674f, 4.48f)
                lineTo(11.866f, 4.234f)
                lineTo(11.793f, 4.177f)
                lineTo(11.702f, 4.169f)
                lineTo(11.674f, 4.48f)
                close()
                moveTo(11.573f, 4.471f)
                horizontalLineTo(11.26f)
                verticalLineTo(4.757f)
                lineTo(11.545f, 4.783f)
                lineTo(11.573f, 4.471f)
                close()
                moveTo(8.367f, 4.313f)
                horizontalLineTo(11.573f)
                verticalLineTo(3.688f)
                horizontalLineTo(8.367f)
                verticalLineTo(4.313f)
                close()
                moveTo(8.679f, 4.479f)
                verticalLineTo(4f)
                horizontalLineTo(8.054f)
                verticalLineTo(4.479f)
                horizontalLineTo(8.679f)
                close()
                moveTo(8.373f, 4.792f)
                lineTo(8.395f, 4.79f)
                lineTo(8.339f, 4.167f)
                lineTo(8.318f, 4.169f)
                lineTo(8.373f, 4.792f)
                close()
                moveTo(7.515f, 7.457f)
                curveTo(7.322f, 6.65f, 7.569f, 5.974f, 7.879f, 5.486f)
                curveTo(8.033f, 5.242f, 8.201f, 5.05f, 8.33f, 4.919f)
                curveTo(8.394f, 4.853f, 8.448f, 4.804f, 8.485f, 4.771f)
                curveTo(8.503f, 4.755f, 8.518f, 4.743f, 8.527f, 4.736f)
                curveTo(8.531f, 4.732f, 8.534f, 4.73f, 8.536f, 4.728f)
                curveTo(8.537f, 4.727f, 8.538f, 4.727f, 8.538f, 4.727f)
                curveTo(8.538f, 4.727f, 8.538f, 4.727f, 8.538f, 4.727f)
                curveTo(8.538f, 4.727f, 8.538f, 4.727f, 8.538f, 4.727f)
                curveTo(8.537f, 4.727f, 8.537f, 4.727f, 8.537f, 4.727f)
                curveTo(8.537f, 4.727f, 8.537f, 4.727f, 8.345f, 4.48f)
                curveTo(8.154f, 4.234f, 8.154f, 4.234f, 8.153f, 4.234f)
                curveTo(8.153f, 4.234f, 8.153f, 4.234f, 8.153f, 4.234f)
                curveTo(8.153f, 4.234f, 8.153f, 4.234f, 8.153f, 4.235f)
                curveTo(8.152f, 4.235f, 8.152f, 4.235f, 8.151f, 4.236f)
                curveTo(8.15f, 4.237f, 8.148f, 4.238f, 8.146f, 4.24f)
                curveTo(8.142f, 4.243f, 8.136f, 4.248f, 8.129f, 4.253f)
                curveTo(8.115f, 4.265f, 8.096f, 4.281f, 8.073f, 4.302f)
                curveTo(8.025f, 4.343f, 7.96f, 4.403f, 7.884f, 4.481f)
                curveTo(7.732f, 4.635f, 7.534f, 4.862f, 7.351f, 5.152f)
                curveTo(6.983f, 5.731f, 6.663f, 6.58f, 6.907f, 7.602f)
                lineTo(7.515f, 7.457f)
                close()
                moveTo(9.378f, 10.713f)
                curveTo(9.571f, 10.467f, 9.571f, 10.467f, 9.571f, 10.467f)
                curveTo(9.571f, 10.467f, 9.571f, 10.467f, 9.571f, 10.467f)
                curveTo(9.571f, 10.467f, 9.571f, 10.467f, 9.571f, 10.467f)
                curveTo(9.571f, 10.467f, 9.571f, 10.467f, 9.57f, 10.467f)
                curveTo(9.57f, 10.467f, 9.569f, 10.466f, 9.568f, 10.465f)
                curveTo(9.565f, 10.463f, 9.561f, 10.46f, 9.555f, 10.455f)
                curveTo(9.544f, 10.446f, 9.527f, 10.432f, 9.504f, 10.413f)
                curveTo(9.459f, 10.375f, 9.393f, 10.317f, 9.312f, 10.243f)
                curveTo(9.15f, 10.094f, 8.929f, 9.876f, 8.695f, 9.603f)
                curveTo(8.223f, 9.053f, 7.716f, 8.302f, 7.515f, 7.457f)
                lineTo(6.907f, 7.602f)
                curveTo(7.141f, 8.585f, 7.718f, 9.425f, 8.221f, 10.01f)
                curveTo(8.474f, 10.305f, 8.713f, 10.541f, 8.889f, 10.703f)
                curveTo(8.977f, 10.784f, 9.05f, 10.847f, 9.101f, 10.89f)
                curveTo(9.127f, 10.912f, 9.147f, 10.929f, 9.162f, 10.94f)
                curveTo(9.169f, 10.946f, 9.174f, 10.95f, 9.178f, 10.954f)
                curveTo(9.18f, 10.955f, 9.182f, 10.957f, 9.183f, 10.957f)
                curveTo(9.184f, 10.958f, 9.184f, 10.958f, 9.184f, 10.959f)
                curveTo(9.185f, 10.959f, 9.185f, 10.959f, 9.185f, 10.959f)
                curveTo(9.185f, 10.959f, 9.185f, 10.959f, 9.185f, 10.959f)
                curveTo(9.185f, 10.959f, 9.185f, 10.959f, 9.378f, 10.713f)
                close()
                moveTo(9.164f, 10.314f)
                lineTo(9.077f, 10.63f)
                lineTo(9.679f, 10.797f)
                lineTo(9.766f, 10.481f)
                lineTo(9.164f, 10.314f)
                close()
                moveTo(7.503f, 7.258f)
                curveTo(7.503f, 7.556f, 7.633f, 7.918f, 7.789f, 8.257f)
                curveTo(7.951f, 8.61f, 8.165f, 8.986f, 8.374f, 9.327f)
                curveTo(8.584f, 9.67f, 8.793f, 9.983f, 8.95f, 10.211f)
                curveTo(9.029f, 10.324f, 9.094f, 10.417f, 9.14f, 10.481f)
                curveTo(9.163f, 10.514f, 9.181f, 10.539f, 9.194f, 10.556f)
                curveTo(9.2f, 10.564f, 9.205f, 10.571f, 9.208f, 10.576f)
                curveTo(9.21f, 10.578f, 9.211f, 10.58f, 9.212f, 10.581f)
                curveTo(9.212f, 10.581f, 9.213f, 10.582f, 9.213f, 10.582f)
                curveTo(9.213f, 10.582f, 9.213f, 10.583f, 9.213f, 10.583f)
                curveTo(9.213f, 10.583f, 9.213f, 10.583f, 9.213f, 10.583f)
                curveTo(9.213f, 10.583f, 9.214f, 10.583f, 9.465f, 10.398f)
                curveTo(9.717f, 10.212f, 9.717f, 10.213f, 9.717f, 10.213f)
                curveTo(9.717f, 10.213f, 9.717f, 10.213f, 9.717f, 10.212f)
                curveTo(9.717f, 10.212f, 9.717f, 10.212f, 9.717f, 10.212f)
                curveTo(9.717f, 10.212f, 9.716f, 10.212f, 9.716f, 10.211f)
                curveTo(9.715f, 10.21f, 9.714f, 10.209f, 9.713f, 10.207f)
                curveTo(9.71f, 10.203f, 9.705f, 10.197f, 9.7f, 10.189f)
                curveTo(9.688f, 10.173f, 9.671f, 10.149f, 9.649f, 10.118f)
                curveTo(9.604f, 10.056f, 9.541f, 9.966f, 9.465f, 9.856f)
                curveTo(9.312f, 9.634f, 9.109f, 9.331f, 8.907f, 9.001f)
                curveTo(8.704f, 8.669f, 8.505f, 8.317f, 8.357f, 7.996f)
                curveTo(8.204f, 7.663f, 8.128f, 7.409f, 8.128f, 7.258f)
                horizontalLineTo(7.503f)
                close()
                moveTo(8.341f, 5.099f)
                curveTo(8.174f, 5.165f, 8.049f, 5.302f, 7.959f, 5.435f)
                curveTo(7.864f, 5.575f, 7.783f, 5.747f, 7.717f, 5.933f)
                curveTo(7.586f, 6.307f, 7.503f, 6.777f, 7.503f, 7.258f)
                horizontalLineTo(8.128f)
                curveTo(8.128f, 6.843f, 8.2f, 6.444f, 8.307f, 6.14f)
                curveTo(8.361f, 5.988f, 8.42f, 5.869f, 8.476f, 5.786f)
                curveTo(8.536f, 5.697f, 8.574f, 5.679f, 8.572f, 5.68f)
                lineTo(8.341f, 5.099f)
                close()
                moveTo(8.875f, 5.069f)
                curveTo(8.838f, 5.052f, 8.755f, 5.012f, 8.633f, 5.02f)
                curveTo(8.541f, 5.026f, 8.444f, 5.058f, 8.341f, 5.099f)
                lineTo(8.572f, 5.68f)
                curveTo(8.616f, 5.663f, 8.645f, 5.653f, 8.663f, 5.647f)
                curveTo(8.682f, 5.642f, 8.684f, 5.643f, 8.675f, 5.644f)
                curveTo(8.669f, 5.644f, 8.661f, 5.644f, 8.651f, 5.643f)
                curveTo(8.64f, 5.642f, 8.63f, 5.64f, 8.62f, 5.638f)
                curveTo(8.611f, 5.635f, 8.605f, 5.633f, 8.603f, 5.632f)
                curveTo(8.602f, 5.632f, 8.603f, 5.632f, 8.611f, 5.635f)
                lineTo(8.875f, 5.069f)
                close()
                moveTo(8.93f, 5.077f)
                curveTo(8.913f, 5.077f, 8.902f, 5.076f, 8.895f, 5.076f)
                curveTo(8.889f, 5.075f, 8.886f, 5.074f, 8.886f, 5.074f)
                curveTo(8.886f, 5.074f, 8.886f, 5.074f, 8.886f, 5.074f)
                curveTo(8.887f, 5.074f, 8.887f, 5.074f, 8.887f, 5.074f)
                curveTo(8.886f, 5.074f, 8.885f, 5.073f, 8.875f, 5.069f)
                lineTo(8.611f, 5.635f)
                curveTo(8.631f, 5.645f, 8.674f, 5.665f, 8.733f, 5.68f)
                curveTo(8.792f, 5.695f, 8.856f, 5.702f, 8.93f, 5.702f)
                verticalLineTo(5.077f)
                close()
                moveTo(9.465f, 5.198f)
                curveTo(9.283f, 4.944f, 9.284f, 4.944f, 9.284f, 4.944f)
                curveTo(9.284f, 4.944f, 9.284f, 4.944f, 9.284f, 4.944f)
                curveTo(9.284f, 4.944f, 9.284f, 4.944f, 9.284f, 4.944f)
                curveTo(9.284f, 4.943f, 9.284f, 4.943f, 9.284f, 4.943f)
                curveTo(9.284f, 4.943f, 9.285f, 4.943f, 9.285f, 4.943f)
                curveTo(9.285f, 4.943f, 9.285f, 4.943f, 9.284f, 4.943f)
                curveTo(9.284f, 4.944f, 9.282f, 4.945f, 9.28f, 4.946f)
                curveTo(9.275f, 4.95f, 9.267f, 4.955f, 9.256f, 4.962f)
                curveTo(9.234f, 4.975f, 9.202f, 4.993f, 9.163f, 5.012f)
                curveTo(9.081f, 5.051f, 8.996f, 5.077f, 8.93f, 5.077f)
                verticalLineTo(5.702f)
                curveTo(9.131f, 5.702f, 9.314f, 5.632f, 9.432f, 5.576f)
                curveTo(9.494f, 5.546f, 9.546f, 5.517f, 9.583f, 5.494f)
                curveTo(9.601f, 5.483f, 9.616f, 5.473f, 9.627f, 5.466f)
                curveTo(9.632f, 5.462f, 9.637f, 5.459f, 9.64f, 5.457f)
                curveTo(9.642f, 5.456f, 9.643f, 5.455f, 9.644f, 5.454f)
                curveTo(9.645f, 5.454f, 9.645f, 5.453f, 9.646f, 5.453f)
                curveTo(9.646f, 5.453f, 9.646f, 5.453f, 9.647f, 5.453f)
                curveTo(9.647f, 5.452f, 9.647f, 5.452f, 9.647f, 5.452f)
                curveTo(9.647f, 5.452f, 9.647f, 5.452f, 9.647f, 5.452f)
                curveTo(9.647f, 5.452f, 9.647f, 5.452f, 9.465f, 5.198f)
                close()
                moveTo(9.824f, 5.077f)
                curveTo(9.837f, 5.077f, 9.836f, 5.08f, 9.819f, 5.073f)
                curveTo(9.803f, 5.066f, 9.782f, 5.054f, 9.76f, 5.038f)
                curveTo(9.738f, 5.023f, 9.719f, 5.007f, 9.705f, 4.995f)
                curveTo(9.698f, 4.989f, 9.693f, 4.984f, 9.691f, 4.981f)
                curveTo(9.689f, 4.98f, 9.688f, 4.979f, 9.688f, 4.979f)
                curveTo(9.688f, 4.979f, 9.688f, 4.979f, 9.688f, 4.979f)
                curveTo(9.688f, 4.979f, 9.689f, 4.979f, 9.689f, 4.98f)
                curveTo(9.689f, 4.98f, 9.689f, 4.98f, 9.689f, 4.98f)
                curveTo(9.689f, 4.98f, 9.689f, 4.98f, 9.689f, 4.98f)
                curveTo(9.689f, 4.98f, 9.689f, 4.98f, 9.689f, 4.98f)
                curveTo(9.689f, 4.98f, 9.689f, 4.98f, 9.465f, 5.198f)
                curveTo(9.241f, 5.416f, 9.241f, 5.416f, 9.241f, 5.416f)
                curveTo(9.241f, 5.416f, 9.241f, 5.416f, 9.241f, 5.416f)
                curveTo(9.241f, 5.416f, 9.242f, 5.416f, 9.242f, 5.416f)
                curveTo(9.242f, 5.416f, 9.242f, 5.417f, 9.242f, 5.417f)
                curveTo(9.242f, 5.417f, 9.243f, 5.418f, 9.243f, 5.418f)
                curveTo(9.244f, 5.419f, 9.245f, 5.42f, 9.247f, 5.421f)
                curveTo(9.249f, 5.424f, 9.253f, 5.427f, 9.257f, 5.431f)
                curveTo(9.265f, 5.439f, 9.276f, 5.449f, 9.289f, 5.461f)
                curveTo(9.316f, 5.485f, 9.354f, 5.517f, 9.4f, 5.55f)
                curveTo(9.48f, 5.605f, 9.637f, 5.702f, 9.824f, 5.702f)
                verticalLineTo(5.077f)
                close()
                moveTo(10f, 5.198f)
                curveTo(9.687f, 5.194f, 9.687f, 5.194f, 9.687f, 5.194f)
                curveTo(9.687f, 5.194f, 9.687f, 5.194f, 9.687f, 5.194f)
                curveTo(9.687f, 5.193f, 9.687f, 5.193f, 9.687f, 5.193f)
                curveTo(9.687f, 5.193f, 9.687f, 5.192f, 9.687f, 5.192f)
                curveTo(9.687f, 5.191f, 9.688f, 5.191f, 9.688f, 5.19f)
                curveTo(9.688f, 5.189f, 9.688f, 5.188f, 9.688f, 5.187f)
                curveTo(9.688f, 5.185f, 9.688f, 5.183f, 9.688f, 5.182f)
                curveTo(9.688f, 5.18f, 9.688f, 5.179f, 9.688f, 5.178f)
                curveTo(9.688f, 5.177f, 9.689f, 5.172f, 9.694f, 5.162f)
                curveTo(9.698f, 5.152f, 9.711f, 5.129f, 9.74f, 5.107f)
                curveTo(9.773f, 5.084f, 9.806f, 5.077f, 9.824f, 5.077f)
                verticalLineTo(5.702f)
                curveTo(9.929f, 5.702f, 10.028f, 5.672f, 10.109f, 5.612f)
                curveTo(10.188f, 5.555f, 10.234f, 5.483f, 10.26f, 5.425f)
                curveTo(10.287f, 5.368f, 10.299f, 5.315f, 10.305f, 5.278f)
                curveTo(10.308f, 5.259f, 10.31f, 5.243f, 10.311f, 5.23f)
                curveTo(10.311f, 5.224f, 10.312f, 5.218f, 10.312f, 5.214f)
                curveTo(10.312f, 5.211f, 10.312f, 5.209f, 10.312f, 5.207f)
                curveTo(10.312f, 5.206f, 10.312f, 5.205f, 10.312f, 5.204f)
                curveTo(10.312f, 5.204f, 10.312f, 5.203f, 10.312f, 5.203f)
                curveTo(10.312f, 5.203f, 10.312f, 5.203f, 10.312f, 5.203f)
                curveTo(10.312f, 5.202f, 10.312f, 5.202f, 10.312f, 5.202f)
                curveTo(10.312f, 5.202f, 10.312f, 5.202f, 10f, 5.198f)
                close()
                moveTo(9.687f, 4.563f)
                verticalLineTo(5.198f)
                horizontalLineTo(10.312f)
                verticalLineTo(4.563f)
                horizontalLineTo(9.687f)
                close()
                moveTo(10.019f, 4.25f)
                horizontalLineTo(10f)
                verticalLineTo(4.875f)
                horizontalLineTo(10.019f)
                verticalLineTo(4.25f)
                close()
                moveTo(9.707f, 4.563f)
                verticalLineTo(5.198f)
                horizontalLineTo(10.332f)
                verticalLineTo(4.563f)
                horizontalLineTo(9.707f)
                close()
                moveTo(10.019f, 5.198f)
                curveTo(9.707f, 5.202f, 9.707f, 5.202f, 9.707f, 5.202f)
                curveTo(9.707f, 5.202f, 9.707f, 5.202f, 9.707f, 5.203f)
                curveTo(9.707f, 5.203f, 9.707f, 5.203f, 9.707f, 5.203f)
                curveTo(9.707f, 5.203f, 9.707f, 5.204f, 9.707f, 5.204f)
                curveTo(9.707f, 5.205f, 9.707f, 5.206f, 9.707f, 5.207f)
                curveTo(9.707f, 5.209f, 9.707f, 5.211f, 9.707f, 5.214f)
                curveTo(9.707f, 5.218f, 9.708f, 5.224f, 9.708f, 5.23f)
                curveTo(9.709f, 5.243f, 9.711f, 5.259f, 9.714f, 5.278f)
                curveTo(9.72f, 5.315f, 9.732f, 5.368f, 9.759f, 5.425f)
                curveTo(9.785f, 5.483f, 9.832f, 5.555f, 9.91f, 5.612f)
                curveTo(9.992f, 5.672f, 10.09f, 5.702f, 10.195f, 5.702f)
                verticalLineTo(5.077f)
                curveTo(10.213f, 5.077f, 10.246f, 5.084f, 10.279f, 5.107f)
                curveTo(10.308f, 5.129f, 10.321f, 5.152f, 10.326f, 5.162f)
                curveTo(10.33f, 5.172f, 10.331f, 5.177f, 10.331f, 5.178f)
                curveTo(10.331f, 5.179f, 10.331f, 5.18f, 10.331f, 5.182f)
                curveTo(10.331f, 5.183f, 10.332f, 5.185f, 10.332f, 5.187f)
                curveTo(10.332f, 5.188f, 10.332f, 5.189f, 10.332f, 5.19f)
                curveTo(10.332f, 5.191f, 10.332f, 5.191f, 10.332f, 5.192f)
                curveTo(10.332f, 5.192f, 10.332f, 5.193f, 10.332f, 5.193f)
                curveTo(10.332f, 5.193f, 10.332f, 5.193f, 10.332f, 5.194f)
                curveTo(10.332f, 5.194f, 10.332f, 5.194f, 10.332f, 5.194f)
                curveTo(10.332f, 5.194f, 10.332f, 5.194f, 10.019f, 5.198f)
                close()
                moveTo(10.195f, 5.702f)
                curveTo(10.382f, 5.702f, 10.539f, 5.605f, 10.619f, 5.55f)
                curveTo(10.665f, 5.517f, 10.703f, 5.485f, 10.73f, 5.461f)
                curveTo(10.743f, 5.449f, 10.755f, 5.439f, 10.763f, 5.431f)
                curveTo(10.767f, 5.427f, 10.77f, 5.424f, 10.773f, 5.421f)
                curveTo(10.774f, 5.42f, 10.775f, 5.419f, 10.776f, 5.418f)
                curveTo(10.776f, 5.418f, 10.777f, 5.417f, 10.777f, 5.417f)
                curveTo(10.777f, 5.417f, 10.777f, 5.416f, 10.778f, 5.416f)
                curveTo(10.778f, 5.416f, 10.778f, 5.416f, 10.778f, 5.416f)
                curveTo(10.778f, 5.416f, 10.778f, 5.416f, 10.778f, 5.416f)
                curveTo(10.778f, 5.416f, 10.778f, 5.416f, 10.554f, 5.198f)
                curveTo(10.33f, 4.98f, 10.33f, 4.98f, 10.33f, 4.98f)
                curveTo(10.33f, 4.98f, 10.33f, 4.98f, 10.33f, 4.98f)
                curveTo(10.33f, 4.98f, 10.33f, 4.98f, 10.33f, 4.98f)
                curveTo(10.33f, 4.98f, 10.33f, 4.98f, 10.33f, 4.98f)
                curveTo(10.331f, 4.979f, 10.331f, 4.979f, 10.331f, 4.979f)
                curveTo(10.331f, 4.979f, 10.331f, 4.979f, 10.331f, 4.979f)
                curveTo(10.331f, 4.979f, 10.33f, 4.98f, 10.329f, 4.981f)
                curveTo(10.326f, 4.984f, 10.321f, 4.989f, 10.314f, 4.995f)
                curveTo(10.301f, 5.007f, 10.281f, 5.023f, 10.26f, 5.038f)
                curveTo(10.237f, 5.054f, 10.217f, 5.066f, 10.2f, 5.073f)
                curveTo(10.183f, 5.08f, 10.182f, 5.077f, 10.195f, 5.077f)
                verticalLineTo(5.702f)
                close()
                moveTo(10.554f, 5.198f)
                curveTo(10.372f, 5.452f, 10.372f, 5.452f, 10.372f, 5.452f)
                curveTo(10.372f, 5.452f, 10.372f, 5.452f, 10.372f, 5.452f)
                curveTo(10.373f, 5.452f, 10.373f, 5.452f, 10.373f, 5.453f)
                curveTo(10.373f, 5.453f, 10.373f, 5.453f, 10.373f, 5.453f)
                curveTo(10.374f, 5.453f, 10.374f, 5.454f, 10.375f, 5.454f)
                curveTo(10.376f, 5.455f, 10.377f, 5.456f, 10.379f, 5.457f)
                curveTo(10.382f, 5.459f, 10.387f, 5.462f, 10.392f, 5.466f)
                curveTo(10.403f, 5.473f, 10.418f, 5.483f, 10.437f, 5.494f)
                curveTo(10.473f, 5.517f, 10.525f, 5.546f, 10.587f, 5.576f)
                curveTo(10.705f, 5.632f, 10.888f, 5.702f, 11.09f, 5.702f)
                verticalLineTo(5.077f)
                curveTo(11.023f, 5.077f, 10.939f, 5.051f, 10.856f, 5.012f)
                curveTo(10.818f, 4.993f, 10.785f, 4.975f, 10.763f, 4.962f)
                curveTo(10.752f, 4.955f, 10.744f, 4.95f, 10.74f, 4.946f)
                curveTo(10.737f, 4.945f, 10.736f, 4.944f, 10.735f, 4.943f)
                curveTo(10.735f, 4.943f, 10.734f, 4.943f, 10.735f, 4.943f)
                curveTo(10.735f, 4.943f, 10.735f, 4.943f, 10.735f, 4.943f)
                curveTo(10.735f, 4.943f, 10.735f, 4.943f, 10.735f, 4.944f)
                curveTo(10.735f, 4.944f, 10.736f, 4.944f, 10.736f, 4.944f)
                curveTo(10.736f, 4.944f, 10.736f, 4.944f, 10.736f, 4.944f)
                curveTo(10.736f, 4.944f, 10.736f, 4.944f, 10.554f, 5.198f)
                close()
                moveTo(11.09f, 5.702f)
                curveTo(11.163f, 5.702f, 11.227f, 5.695f, 11.286f, 5.68f)
                curveTo(11.345f, 5.665f, 11.388f, 5.645f, 11.409f, 5.635f)
                lineTo(11.144f, 5.069f)
                curveTo(11.135f, 5.073f, 11.133f, 5.074f, 11.132f, 5.074f)
                curveTo(11.132f, 5.074f, 11.132f, 5.074f, 11.133f, 5.074f)
                curveTo(11.133f, 5.074f, 11.133f, 5.074f, 11.133f, 5.074f)
                curveTo(11.133f, 5.074f, 11.13f, 5.075f, 11.124f, 5.076f)
                curveTo(11.117f, 5.076f, 11.106f, 5.077f, 11.09f, 5.077f)
                verticalLineTo(5.702f)
                close()
                moveTo(11.409f, 5.635f)
                curveTo(11.417f, 5.632f, 11.417f, 5.632f, 11.416f, 5.632f)
                curveTo(11.414f, 5.633f, 11.408f, 5.635f, 11.399f, 5.638f)
                curveTo(11.389f, 5.64f, 11.379f, 5.642f, 11.369f, 5.643f)
                curveTo(11.358f, 5.644f, 11.35f, 5.644f, 11.345f, 5.644f)
                curveTo(11.335f, 5.643f, 11.337f, 5.642f, 11.356f, 5.647f)
                curveTo(11.374f, 5.653f, 11.403f, 5.663f, 11.448f, 5.68f)
                lineTo(11.678f, 5.099f)
                curveTo(11.575f, 5.058f, 11.479f, 5.026f, 11.387f, 5.02f)
                curveTo(11.264f, 5.012f, 11.182f, 5.052f, 11.144f, 5.069f)
                lineTo(11.409f, 5.635f)
                close()
                moveTo(11.448f, 5.68f)
                curveTo(11.446f, 5.679f, 11.483f, 5.697f, 11.543f, 5.786f)
                curveTo(11.6f, 5.869f, 11.659f, 5.988f, 11.712f, 6.14f)
                curveTo(11.819f, 6.444f, 11.891f, 6.843f, 11.891f, 7.258f)
                horizontalLineTo(12.516f)
                curveTo(12.516f, 6.777f, 12.433f, 6.307f, 12.302f, 5.933f)
                curveTo(12.236f, 5.747f, 12.156f, 5.575f, 12.061f, 5.435f)
                curveTo(11.97f, 5.302f, 11.845f, 5.165f, 11.678f, 5.099f)
                lineTo(11.448f, 5.68f)
                close()
                moveTo(11.891f, 7.258f)
                curveTo(11.891f, 7.409f, 11.815f, 7.663f, 11.662f, 7.996f)
                curveTo(11.515f, 8.317f, 11.316f, 8.669f, 11.112f, 9.001f)
                curveTo(10.91f, 9.331f, 10.707f, 9.634f, 10.554f, 9.856f)
                curveTo(10.478f, 9.966f, 10.415f, 10.056f, 10.371f, 10.118f)
                curveTo(10.349f, 10.149f, 10.331f, 10.173f, 10.32f, 10.189f)
                curveTo(10.314f, 10.197f, 10.309f, 10.203f, 10.306f, 10.207f)
                curveTo(10.305f, 10.209f, 10.304f, 10.21f, 10.303f, 10.211f)
                curveTo(10.303f, 10.212f, 10.302f, 10.212f, 10.302f, 10.212f)
                curveTo(10.302f, 10.212f, 10.302f, 10.212f, 10.302f, 10.212f)
                curveTo(10.302f, 10.213f, 10.302f, 10.213f, 10.302f, 10.213f)
                curveTo(10.302f, 10.213f, 10.302f, 10.212f, 10.554f, 10.398f)
                curveTo(10.806f, 10.583f, 10.806f, 10.583f, 10.806f, 10.583f)
                curveTo(10.806f, 10.583f, 10.806f, 10.583f, 10.806f, 10.583f)
                curveTo(10.806f, 10.583f, 10.806f, 10.582f, 10.806f, 10.582f)
                curveTo(10.806f, 10.582f, 10.807f, 10.581f, 10.807f, 10.581f)
                curveTo(10.808f, 10.58f, 10.809f, 10.578f, 10.811f, 10.576f)
                curveTo(10.814f, 10.571f, 10.819f, 10.564f, 10.825f, 10.556f)
                curveTo(10.838f, 10.539f, 10.856f, 10.514f, 10.879f, 10.481f)
                curveTo(10.925f, 10.417f, 10.991f, 10.324f, 11.069f, 10.211f)
                curveTo(11.226f, 9.983f, 11.435f, 9.67f, 11.645f, 9.327f)
                curveTo(11.855f, 8.986f, 12.068f, 8.61f, 12.23f, 8.257f)
                curveTo(12.386f, 7.918f, 12.516f, 7.556f, 12.516f, 7.258f)
                horizontalLineTo(11.891f)
                close()
                moveTo(10.253f, 10.481f)
                lineTo(10.34f, 10.797f)
                lineTo(10.942f, 10.63f)
                lineTo(10.855f, 10.314f)
                lineTo(10.253f, 10.481f)
                close()
                moveTo(10.641f, 10.713f)
                curveTo(10.834f, 10.959f, 10.834f, 10.959f, 10.834f, 10.959f)
                curveTo(10.834f, 10.959f, 10.834f, 10.959f, 10.834f, 10.959f)
                curveTo(10.834f, 10.959f, 10.835f, 10.959f, 10.835f, 10.959f)
                curveTo(10.835f, 10.958f, 10.836f, 10.958f, 10.836f, 10.957f)
                curveTo(10.837f, 10.957f, 10.839f, 10.955f, 10.841f, 10.954f)
                curveTo(10.845f, 10.95f, 10.851f, 10.946f, 10.858f, 10.94f)
                curveTo(10.872f, 10.929f, 10.892f, 10.912f, 10.918f, 10.89f)
                curveTo(10.969f, 10.847f, 11.042f, 10.784f, 11.13f, 10.703f)
                curveTo(11.306f, 10.541f, 11.545f, 10.305f, 11.799f, 10.01f)
                curveTo(12.301f, 9.425f, 12.878f, 8.585f, 13.112f, 7.602f)
                lineTo(12.505f, 7.457f)
                curveTo(12.303f, 8.302f, 11.796f, 9.053f, 11.324f, 9.603f)
                curveTo(11.09f, 9.876f, 10.869f, 10.094f, 10.707f, 10.243f)
                curveTo(10.626f, 10.317f, 10.56f, 10.375f, 10.515f, 10.413f)
                curveTo(10.493f, 10.432f, 10.475f, 10.446f, 10.464f, 10.455f)
                curveTo(10.458f, 10.46f, 10.454f, 10.463f, 10.451f, 10.465f)
                curveTo(10.45f, 10.466f, 10.449f, 10.467f, 10.449f, 10.467f)
                curveTo(10.448f, 10.467f, 10.448f, 10.467f, 10.448f, 10.467f)
                curveTo(10.448f, 10.467f, 10.448f, 10.467f, 10.448f, 10.467f)
                curveTo(10.448f, 10.467f, 10.448f, 10.467f, 10.448f, 10.467f)
                curveTo(10.448f, 10.467f, 10.448f, 10.467f, 10.641f, 10.713f)
                close()
                moveTo(13.112f, 7.602f)
                curveTo(13.356f, 6.58f, 13.036f, 5.731f, 12.668f, 5.152f)
                curveTo(12.485f, 4.862f, 12.287f, 4.635f, 12.135f, 4.481f)
                curveTo(12.059f, 4.403f, 11.994f, 4.343f, 11.946f, 4.302f)
                curveTo(11.923f, 4.281f, 11.904f, 4.265f, 11.89f, 4.253f)
                curveTo(11.883f, 4.248f, 11.877f, 4.243f, 11.873f, 4.24f)
                curveTo(11.871f, 4.238f, 11.87f, 4.237f, 11.868f, 4.236f)
                curveTo(11.868f, 4.235f, 11.867f, 4.235f, 11.867f, 4.235f)
                curveTo(11.866f, 4.234f, 11.866f, 4.234f, 11.866f, 4.234f)
                curveTo(11.866f, 4.234f, 11.866f, 4.234f, 11.866f, 4.234f)
                curveTo(11.866f, 4.234f, 11.866f, 4.234f, 11.674f, 4.48f)
                curveTo(11.482f, 4.727f, 11.482f, 4.727f, 11.482f, 4.727f)
                curveTo(11.482f, 4.727f, 11.482f, 4.727f, 11.482f, 4.727f)
                curveTo(11.482f, 4.727f, 11.481f, 4.727f, 11.481f, 4.727f)
                curveTo(11.481f, 4.727f, 11.481f, 4.727f, 11.481f, 4.727f)
                curveTo(11.482f, 4.727f, 11.482f, 4.727f, 11.483f, 4.728f)
                curveTo(11.485f, 4.73f, 11.488f, 4.732f, 11.493f, 4.736f)
                curveTo(11.502f, 4.743f, 11.516f, 4.755f, 11.534f, 4.771f)
                curveTo(11.571f, 4.804f, 11.625f, 4.853f, 11.689f, 4.919f)
                curveTo(11.818f, 5.05f, 11.986f, 5.242f, 12.141f, 5.486f)
                curveTo(12.45f, 5.974f, 12.697f, 6.65f, 12.505f, 7.457f)
                lineTo(13.112f, 7.602f)
                close()
                moveTo(11.702f, 4.169f)
                lineTo(11.6f, 4.16f)
                lineTo(11.545f, 4.783f)
                lineTo(11.646f, 4.792f)
                lineTo(11.702f, 4.169f)
                close()
                moveTo(11.26f, 4f)
                verticalLineTo(4.471f)
                horizontalLineTo(11.885f)
                verticalLineTo(4f)
                horizontalLineTo(11.26f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF8FC753)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.19f, 8.616f)
                curveTo(8.19f, 8.616f, 8.386f, 8.088f, 8.73f, 8.264f)
                curveTo(9.074f, 8.44f, 9.044f, 9.052f, 9.356f, 8.834f)
                curveTo(9.669f, 8.616f, 9.492f, 8.264f, 9.955f, 8.264f)
                curveTo(10.419f, 8.264f, 10.35f, 8.834f, 10.628f, 8.834f)
                curveTo(10.906f, 8.834f, 10.93f, 8.264f, 11.241f, 8.264f)
                curveTo(11.552f, 8.264f, 11.867f, 8.616f, 11.867f, 8.616f)
                lineTo(10.028f, 11.117f)
                lineTo(8.19f, 8.616f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.956f, 11.536f)
                lineTo(4.758f, 11.269f)
                curveTo(4.758f, 11.269f, 5.578f, 11.269f, 5.689f, 11.462f)
                curveTo(5.72f, 11.517f, 5.734f, 11.558f, 5.745f, 11.59f)
                curveTo(5.771f, 11.67f, 5.776f, 11.686f, 5.999f, 11.686f)
                curveTo(6.309f, 11.686f, 5.999f, 11.379f, 5.87f, 11.269f)
                curveTo(5.741f, 11.16f, 5.819f, 10.969f, 5.999f, 10.969f)
                curveTo(6.068f, 10.969f, 6.188f, 10.953f, 6.336f, 10.933f)
                curveTo(6.572f, 10.902f, 6.878f, 10.862f, 7.159f, 10.862f)
                curveTo(7.615f, 10.862f, 7.237f, 11.269f, 7.237f, 11.269f)
                curveTo(7.237f, 11.269f, 7.827f, 11.269f, 7.681f, 11.1f)
                curveTo(7.534f, 10.93f, 8.173f, 10.724f, 8.449f, 10.724f)
                curveTo(8.707f, 10.724f, 9.866f, 10.782f, 10.022f, 10.79f)
                curveTo(10.185f, 10.782f, 11.396f, 10.724f, 11.653f, 10.724f)
                curveTo(11.929f, 10.724f, 12.569f, 10.93f, 12.422f, 11.1f)
                curveTo(12.275f, 11.269f, 12.866f, 11.269f, 12.866f, 11.269f)
                curveTo(12.866f, 11.269f, 12.488f, 10.862f, 12.944f, 10.862f)
                curveTo(13.225f, 10.862f, 13.531f, 10.902f, 13.767f, 10.933f)
                curveTo(13.915f, 10.953f, 14.035f, 10.969f, 14.104f, 10.969f)
                curveTo(14.283f, 10.969f, 14.362f, 11.16f, 14.233f, 11.269f)
                curveTo(14.104f, 11.379f, 13.794f, 11.686f, 14.104f, 11.686f)
                curveTo(14.326f, 11.686f, 14.332f, 11.67f, 14.358f, 11.59f)
                curveTo(14.369f, 11.558f, 14.382f, 11.517f, 14.414f, 11.462f)
                curveTo(14.521f, 11.276f, 15.288f, 11.27f, 15.342f, 11.269f)
                curveTo(15.33f, 11.247f, 15.323f, 11.221f, 15.323f, 11.193f)
                curveTo(15.323f, 11.106f, 15.39f, 11.037f, 15.474f, 11.037f)
                curveTo(15.557f, 11.037f, 15.625f, 11.106f, 15.625f, 11.193f)
                curveTo(15.625f, 11.279f, 15.557f, 11.349f, 15.474f, 11.349f)
                curveTo(15.418f, 11.349f, 15.37f, 11.318f, 15.343f, 11.272f)
                lineTo(15.147f, 11.536f)
                lineTo(15.351f, 11.789f)
                curveTo(15.379f, 11.75f, 15.424f, 11.724f, 15.474f, 11.724f)
                curveTo(15.557f, 11.724f, 15.625f, 11.794f, 15.625f, 11.88f)
                curveTo(15.625f, 11.967f, 15.557f, 12.037f, 15.474f, 12.037f)
                curveTo(15.39f, 12.037f, 15.323f, 11.967f, 15.323f, 11.88f)
                curveTo(15.323f, 11.863f, 15.325f, 11.845f, 15.331f, 11.829f)
                curveTo(15.215f, 11.773f, 15.015f, 11.686f, 14.886f, 11.686f)
                horizontalLineTo(14.525f)
                curveTo(14.616f, 11.686f, 15.116f, 12.016f, 14.964f, 12.159f)
                lineTo(14.939f, 12.183f)
                curveTo(14.79f, 12.324f, 14.596f, 12.509f, 14.414f, 12.408f)
                curveTo(14.22f, 12.302f, 14.104f, 12.159f, 14.104f, 12.159f)
                lineTo(13.952f, 11.686f)
                curveTo(13.952f, 11.686f, 13.059f, 11.456f, 13.059f, 11.615f)
                curveTo(13.059f, 11.775f, 13.057f, 11.853f, 12.74f, 11.853f)
                curveTo(12.563f, 11.853f, 12.391f, 11.823f, 12.241f, 11.797f)
                curveTo(12.122f, 11.776f, 12.016f, 11.757f, 11.929f, 11.757f)
                curveTo(11.806f, 11.757f, 11.615f, 11.795f, 11.474f, 11.823f)
                curveTo(11.391f, 11.84f, 11.325f, 11.853f, 11.3f, 11.853f)
                curveTo(11.233f, 11.853f, 10.871f, 11.837f, 11.119f, 11.686f)
                curveTo(11.367f, 11.536f, 11.424f, 11.379f, 11.424f, 11.379f)
                curveTo(11.424f, 11.379f, 10.432f, 11.526f, 10.039f, 11.535f)
                verticalLineTo(11.536f)
                lineTo(10.021f, 11.536f)
                lineTo(10.003f, 11.536f)
                verticalLineTo(11.535f)
                curveTo(9.614f, 11.526f, 8.679f, 11.379f, 8.679f, 11.379f)
                curveTo(8.679f, 11.379f, 8.736f, 11.536f, 8.984f, 11.686f)
                curveTo(9.232f, 11.837f, 8.87f, 11.853f, 8.803f, 11.853f)
                curveTo(8.778f, 11.853f, 8.712f, 11.84f, 8.629f, 11.823f)
                curveTo(8.488f, 11.795f, 8.297f, 11.757f, 8.173f, 11.757f)
                curveTo(8.087f, 11.757f, 7.981f, 11.776f, 7.862f, 11.797f)
                curveTo(7.711f, 11.823f, 7.54f, 11.853f, 7.363f, 11.853f)
                curveTo(7.046f, 11.853f, 7.044f, 11.775f, 7.044f, 11.615f)
                curveTo(7.044f, 11.456f, 6.15f, 11.686f, 6.15f, 11.686f)
                lineTo(5.999f, 12.159f)
                curveTo(5.999f, 12.159f, 5.883f, 12.302f, 5.689f, 12.408f)
                curveTo(5.506f, 12.509f, 5.313f, 12.324f, 5.164f, 12.183f)
                lineTo(5.139f, 12.159f)
                curveTo(4.987f, 12.016f, 5.487f, 11.686f, 5.578f, 11.686f)
                horizontalLineTo(5.217f)
                curveTo(5.025f, 11.686f, 4.681f, 11.876f, 4.681f, 11.876f)
                lineTo(4.956f, 11.536f)
                close()
                moveTo(4.526f, 11.349f)
                curveTo(4.61f, 11.349f, 4.677f, 11.279f, 4.677f, 11.193f)
                curveTo(4.677f, 11.106f, 4.61f, 11.037f, 4.526f, 11.037f)
                curveTo(4.443f, 11.037f, 4.375f, 11.106f, 4.375f, 11.193f)
                curveTo(4.375f, 11.279f, 4.443f, 11.349f, 4.526f, 11.349f)
                close()
                moveTo(4.526f, 12.037f)
                curveTo(4.61f, 12.037f, 4.677f, 11.967f, 4.677f, 11.88f)
                curveTo(4.677f, 11.794f, 4.61f, 11.724f, 4.526f, 11.724f)
                curveTo(4.443f, 11.724f, 4.375f, 11.794f, 4.375f, 11.88f)
                curveTo(4.375f, 11.967f, 4.443f, 12.037f, 4.526f, 12.037f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.934f, 1.268f)
                horizontalLineTo(10.059f)
                verticalLineTo(1.402f)
                horizontalLineTo(10.212f)
                verticalLineTo(1.527f)
                horizontalLineTo(10.059f)
                verticalLineTo(1.755f)
                curveTo(10.231f, 1.784f, 10.363f, 1.939f, 10.363f, 2.125f)
                curveTo(10.363f, 2.332f, 10.2f, 2.5f, 10f, 2.5f)
                curveTo(9.8f, 2.5f, 9.637f, 2.332f, 9.637f, 2.125f)
                curveTo(9.637f, 1.941f, 9.765f, 1.788f, 9.934f, 1.756f)
                verticalLineTo(1.527f)
                horizontalLineTo(9.793f)
                verticalLineTo(1.402f)
                horizontalLineTo(9.934f)
                verticalLineTo(1.268f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.592f, 3.266f)
                curveTo(8.417f, 3.266f, 8.048f, 3.453f, 8.048f, 3.453f)
                lineTo(8.335f, 4.09f)
                lineTo(10.065f, 4.025f)
                lineTo(11.795f, 4.09f)
                lineTo(12.082f, 3.453f)
                curveTo(12.082f, 3.453f, 11.713f, 3.266f, 11.538f, 3.266f)
                curveTo(11.462f, 3.266f, 11.452f, 3.221f, 11.441f, 3.17f)
                curveTo(11.427f, 3.105f, 11.411f, 3.032f, 11.251f, 3.032f)
                curveTo(11.138f, 3.032f, 11.058f, 3.051f, 10.993f, 3.066f)
                curveTo(10.894f, 3.089f, 10.831f, 3.104f, 10.74f, 3.032f)
                curveTo(10.736f, 3.029f, 10.732f, 3.026f, 10.728f, 3.023f)
                curveTo(10.581f, 2.906f, 10.427f, 2.785f, 10.179f, 2.785f)
                curveTo(10.13f, 2.785f, 10.093f, 2.832f, 10.065f, 2.907f)
                curveTo(10.038f, 2.832f, 10.001f, 2.785f, 9.951f, 2.785f)
                curveTo(9.703f, 2.785f, 9.55f, 2.906f, 9.402f, 3.023f)
                curveTo(9.398f, 3.026f, 9.394f, 3.029f, 9.39f, 3.032f)
                curveTo(9.299f, 3.104f, 9.236f, 3.089f, 9.137f, 3.066f)
                curveTo(9.073f, 3.051f, 8.993f, 3.032f, 8.879f, 3.032f)
                curveTo(8.719f, 3.032f, 8.703f, 3.105f, 8.689f, 3.17f)
                curveTo(8.678f, 3.221f, 8.669f, 3.266f, 8.592f, 3.266f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.755f, 2.23f)
                lineTo(9.634f, 2.272f)
                curveTo(9.313f, 2.384f, 9.035f, 2.421f, 8.8f, 2.384f)
                curveTo(8.316f, 2.31f, 7.686f, 2.561f, 7.765f, 2.93f)
                curveTo(7.799f, 3.091f, 7.9f, 3.396f, 8.006f, 3.654f)
                curveTo(8.151f, 4.013f, 8.254f, 4.194f, 8.373f, 4.194f)
                curveTo(8.388f, 4.194f, 8.551f, 4.203f, 8.605f, 4.205f)
                curveTo(8.614f, 4.206f, 8.621f, 4.206f, 8.622f, 4.206f)
                curveTo(8.798f, 4.215f, 8.952f, 4.22f, 9.101f, 4.219f)
                curveTo(9.532f, 4.217f, 9.799f, 4.175f, 9.894f, 4.046f)
                lineTo(9.922f, 4.008f)
                lineTo(9.909f, 3.962f)
                curveTo(9.796f, 3.573f, 9.744f, 3.039f, 9.753f, 2.363f)
                lineTo(9.755f, 2.23f)
                close()
                moveTo(7.942f, 2.889f)
                curveTo(7.903f, 2.708f, 8.397f, 2.512f, 8.773f, 2.57f)
                curveTo(9.008f, 2.606f, 9.273f, 2.579f, 9.571f, 2.489f)
                curveTo(9.569f, 3.091f, 9.618f, 3.58f, 9.719f, 3.956f)
                curveTo(9.633f, 4.001f, 9.406f, 4.03f, 9.1f, 4.032f)
                curveTo(8.955f, 4.032f, 8.803f, 4.028f, 8.631f, 4.019f)
                curveTo(8.632f, 4.019f, 8.453f, 4.009f, 8.391f, 4.007f)
                curveTo(8.389f, 4.005f, 8.387f, 4.002f, 8.384f, 3.999f)
                curveTo(8.368f, 3.98f, 8.348f, 3.95f, 8.325f, 3.909f)
                curveTo(8.28f, 3.829f, 8.228f, 3.716f, 8.173f, 3.582f)
                curveTo(8.072f, 3.333f, 7.974f, 3.038f, 7.942f, 2.889f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD018)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.284f, 2.23f)
                lineTo(10.406f, 2.272f)
                curveTo(10.727f, 2.384f, 11.005f, 2.421f, 11.239f, 2.384f)
                curveTo(11.723f, 2.31f, 12.354f, 2.561f, 12.274f, 2.93f)
                curveTo(12.24f, 3.091f, 12.139f, 3.396f, 12.034f, 3.654f)
                curveTo(11.888f, 4.013f, 11.786f, 4.194f, 11.666f, 4.194f)
                curveTo(11.651f, 4.194f, 11.489f, 4.203f, 11.434f, 4.205f)
                curveTo(11.425f, 4.206f, 11.419f, 4.206f, 11.417f, 4.206f)
                curveTo(11.242f, 4.215f, 11.087f, 4.22f, 10.938f, 4.219f)
                curveTo(10.507f, 4.217f, 10.24f, 4.175f, 10.145f, 4.046f)
                lineTo(10.117f, 4.008f)
                lineTo(10.13f, 3.962f)
                curveTo(10.243f, 3.573f, 10.296f, 3.039f, 10.286f, 2.363f)
                lineTo(10.284f, 2.23f)
                close()
                moveTo(12.097f, 2.889f)
                curveTo(12.136f, 2.708f, 11.643f, 2.512f, 11.266f, 2.57f)
                curveTo(11.032f, 2.606f, 10.766f, 2.579f, 10.469f, 2.489f)
                curveTo(10.47f, 3.091f, 10.421f, 3.58f, 10.321f, 3.956f)
                curveTo(10.407f, 4.001f, 10.633f, 4.03f, 10.939f, 4.032f)
                curveTo(11.084f, 4.032f, 11.236f, 4.028f, 11.408f, 4.019f)
                curveTo(11.407f, 4.019f, 11.586f, 4.009f, 11.648f, 4.007f)
                curveTo(11.65f, 4.005f, 11.652f, 4.002f, 11.655f, 3.999f)
                curveTo(11.671f, 3.98f, 11.691f, 3.95f, 11.714f, 3.909f)
                curveTo(11.759f, 3.829f, 11.812f, 3.716f, 11.866f, 3.582f)
                curveTo(11.968f, 3.333f, 12.065f, 3.038f, 12.097f, 2.889f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF5E5E5E)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.947f, 4.044f)
                curveTo(11.947f, 4.01f, 11.967f, 3.947f, 12.01f, 3.831f)
                curveTo(12.071f, 3.67f, 12.112f, 3.622f, 12.199f, 3.568f)
                curveTo(12.244f, 3.541f, 12.261f, 3.518f, 12.282f, 3.437f)
                curveTo(12.298f, 3.373f, 12.315f, 3.322f, 12.335f, 3.276f)
                curveTo(12.339f, 3.266f, 12.347f, 3.248f, 12.355f, 3.23f)
                lineTo(12.355f, 3.23f)
                lineTo(12.355f, 3.23f)
                curveTo(12.364f, 3.211f, 12.372f, 3.193f, 12.374f, 3.187f)
                curveTo(12.388f, 3.153f, 12.393f, 3.123f, 12.393f, 3.074f)
                curveTo(12.393f, 3.018f, 12.379f, 2.973f, 12.34f, 2.892f)
                curveTo(12.317f, 2.843f, 12.314f, 2.837f, 12.306f, 2.816f)
                curveTo(12.289f, 2.775f, 12.281f, 2.739f, 12.281f, 2.702f)
                verticalLineTo(2.462f)
                curveTo(12.281f, 2.321f, 12.275f, 2.312f, 12.206f, 2.322f)
                curveTo(12.199f, 2.323f, 12.193f, 2.324f, 12.186f, 2.325f)
                curveTo(12.188f, 2.325f, 12.152f, 2.332f, 12.144f, 2.333f)
                curveTo(12.127f, 2.334f, 12.114f, 2.333f, 12.1f, 2.327f)
                curveTo(12.075f, 2.316f, 12.057f, 2.294f, 12.014f, 2.229f)
                curveTo(11.993f, 2.198f, 11.971f, 2.201f, 11.893f, 2.239f)
                curveTo(11.882f, 2.245f, 11.875f, 2.248f, 11.868f, 2.251f)
                curveTo(11.788f, 2.288f, 11.732f, 2.289f, 11.685f, 2.231f)
                curveTo(11.612f, 2.142f, 11.564f, 2.148f, 11.476f, 2.234f)
                curveTo(11.432f, 2.276f, 11.41f, 2.292f, 11.382f, 2.296f)
                lineTo(11.38f, 2.297f)
                curveTo(11.351f, 2.301f, 11.349f, 2.301f, 11.266f, 2.251f)
                curveTo(11.26f, 2.262f, 11.248f, 2.267f, 11.228f, 2.271f)
                curveTo(11.202f, 2.278f, 11.162f, 2.28f, 11.136f, 2.276f)
                curveTo(11.114f, 2.272f, 11.098f, 2.265f, 11.088f, 2.244f)
                curveTo(11.053f, 2.243f, 11.012f, 2.242f, 10.964f, 2.242f)
                verticalLineTo(2.18f)
                curveTo(11.025f, 2.18f, 11.076f, 2.181f, 11.117f, 2.182f)
                lineTo(11.129f, 2.172f)
                curveTo(11.152f, 2.152f, 11.187f, 2.121f, 11.204f, 2.126f)
                curveTo(11.206f, 2.127f, 11.212f, 2.133f, 11.222f, 2.141f)
                lineTo(11.222f, 2.141f)
                lineTo(11.222f, 2.141f)
                curveTo(11.236f, 2.153f, 11.255f, 2.171f, 11.274f, 2.183f)
                lineTo(11.276f, 2.184f)
                curveTo(11.358f, 2.235f, 11.362f, 2.236f, 11.374f, 2.234f)
                curveTo(11.385f, 2.233f, 11.4f, 2.222f, 11.434f, 2.188f)
                curveTo(11.545f, 2.081f, 11.632f, 2.07f, 11.731f, 2.191f)
                curveTo(11.756f, 2.221f, 11.785f, 2.221f, 11.843f, 2.194f)
                curveTo(11.85f, 2.191f, 11.856f, 2.188f, 11.867f, 2.183f)
                curveTo(11.972f, 2.132f, 12.018f, 2.125f, 12.064f, 2.193f)
                curveTo(12.099f, 2.247f, 12.115f, 2.265f, 12.125f, 2.27f)
                lineTo(12.127f, 2.271f)
                curveTo(12.129f, 2.272f, 12.132f, 2.271f, 12.159f, 2.266f)
                lineTo(12.175f, 2.263f)
                curveTo(12.183f, 2.262f, 12.191f, 2.261f, 12.198f, 2.26f)
                curveTo(12.313f, 2.244f, 12.341f, 2.288f, 12.341f, 2.462f)
                verticalLineTo(2.702f)
                curveTo(12.341f, 2.73f, 12.348f, 2.758f, 12.362f, 2.793f)
                curveTo(12.369f, 2.811f, 12.372f, 2.817f, 12.394f, 2.864f)
                curveTo(12.437f, 2.954f, 12.454f, 3.006f, 12.454f, 3.074f)
                curveTo(12.454f, 3.131f, 12.447f, 3.169f, 12.43f, 3.211f)
                curveTo(12.427f, 3.218f, 12.418f, 3.239f, 12.409f, 3.258f)
                lineTo(12.409f, 3.258f)
                curveTo(12.401f, 3.276f, 12.394f, 3.293f, 12.39f, 3.301f)
                curveTo(12.372f, 3.344f, 12.356f, 3.392f, 12.34f, 3.453f)
                curveTo(12.315f, 3.55f, 12.288f, 3.587f, 12.23f, 3.622f)
                curveTo(12.154f, 3.669f, 12.122f, 3.706f, 12.067f, 3.853f)
                curveTo(12.038f, 3.93f, 12.021f, 3.983f, 12.012f, 4.017f)
                curveTo(12.01f, 4.024f, 12.009f, 4.029f, 12.008f, 4.034f)
                curveTo(12.017f, 4.041f, 12.016f, 4.046f, 12.013f, 4.06f)
                lineTo(12.013f, 4.06f)
                curveTo(12.011f, 4.065f, 12.01f, 4.066f, 12.009f, 4.067f)
                lineTo(12.008f, 4.069f)
                curveTo(12.004f, 4.074f, 12.004f, 4.074f, 12f, 4.077f)
                curveTo(11.998f, 4.078f, 11.997f, 4.08f, 11.995f, 4.081f)
                curveTo(11.996f, 4.08f, 11.997f, 4.08f, 11.998f, 4.079f)
                curveTo(11.994f, 4.084f, 11.989f, 4.09f, 11.983f, 4.098f)
                curveTo(11.924f, 4.175f, 11.85f, 4.175f, 11.778f, 4.1f)
                lineTo(11.821f, 4.056f)
                curveTo(11.868f, 4.105f, 11.9f, 4.105f, 11.936f, 4.059f)
                lineTo(11.947f, 4.044f)
                close()
                moveTo(8.023f, 4.044f)
                curveTo(8.023f, 4.01f, 8.003f, 3.947f, 7.959f, 3.831f)
                curveTo(7.899f, 3.67f, 7.858f, 3.622f, 7.771f, 3.568f)
                curveTo(7.726f, 3.541f, 7.709f, 3.518f, 7.688f, 3.437f)
                curveTo(7.672f, 3.373f, 7.655f, 3.322f, 7.635f, 3.276f)
                curveTo(7.631f, 3.266f, 7.623f, 3.248f, 7.615f, 3.23f)
                lineTo(7.615f, 3.23f)
                lineTo(7.615f, 3.23f)
                lineTo(7.615f, 3.23f)
                lineTo(7.615f, 3.23f)
                curveTo(7.606f, 3.211f, 7.598f, 3.193f, 7.596f, 3.187f)
                curveTo(7.582f, 3.153f, 7.577f, 3.123f, 7.577f, 3.074f)
                curveTo(7.577f, 3.018f, 7.591f, 2.973f, 7.63f, 2.892f)
                curveTo(7.653f, 2.843f, 7.656f, 2.837f, 7.664f, 2.816f)
                curveTo(7.681f, 2.775f, 7.689f, 2.739f, 7.689f, 2.702f)
                verticalLineTo(2.462f)
                curveTo(7.689f, 2.321f, 7.695f, 2.312f, 7.764f, 2.322f)
                curveTo(7.771f, 2.323f, 7.777f, 2.324f, 7.784f, 2.325f)
                curveTo(7.782f, 2.325f, 7.818f, 2.332f, 7.826f, 2.333f)
                curveTo(7.843f, 2.334f, 7.856f, 2.333f, 7.87f, 2.327f)
                curveTo(7.894f, 2.316f, 7.913f, 2.294f, 7.956f, 2.229f)
                curveTo(7.977f, 2.198f, 7.999f, 2.201f, 8.077f, 2.239f)
                curveTo(8.088f, 2.245f, 8.095f, 2.248f, 8.102f, 2.251f)
                curveTo(8.182f, 2.288f, 8.238f, 2.289f, 8.285f, 2.231f)
                curveTo(8.358f, 2.142f, 8.406f, 2.148f, 8.494f, 2.234f)
                curveTo(8.538f, 2.276f, 8.56f, 2.292f, 8.588f, 2.296f)
                lineTo(8.59f, 2.297f)
                curveTo(8.619f, 2.301f, 8.621f, 2.301f, 8.704f, 2.251f)
                curveTo(8.709f, 2.262f, 8.722f, 2.267f, 8.742f, 2.271f)
                curveTo(8.768f, 2.278f, 8.808f, 2.28f, 8.834f, 2.276f)
                curveTo(8.856f, 2.272f, 8.872f, 2.265f, 8.882f, 2.244f)
                curveTo(8.917f, 2.243f, 8.958f, 2.242f, 9.006f, 2.242f)
                verticalLineTo(2.18f)
                curveTo(8.945f, 2.18f, 8.894f, 2.181f, 8.853f, 2.182f)
                lineTo(8.841f, 2.172f)
                curveTo(8.818f, 2.152f, 8.783f, 2.121f, 8.766f, 2.126f)
                curveTo(8.764f, 2.127f, 8.757f, 2.133f, 8.748f, 2.141f)
                lineTo(8.748f, 2.141f)
                lineTo(8.748f, 2.141f)
                lineTo(8.748f, 2.141f)
                lineTo(8.748f, 2.141f)
                curveTo(8.734f, 2.154f, 8.713f, 2.172f, 8.694f, 2.184f)
                curveTo(8.611f, 2.235f, 8.608f, 2.236f, 8.596f, 2.234f)
                curveTo(8.585f, 2.233f, 8.57f, 2.222f, 8.536f, 2.188f)
                curveTo(8.425f, 2.081f, 8.338f, 2.07f, 8.239f, 2.191f)
                curveTo(8.214f, 2.221f, 8.185f, 2.221f, 8.127f, 2.194f)
                curveTo(8.12f, 2.191f, 8.114f, 2.188f, 8.103f, 2.183f)
                curveTo(7.998f, 2.132f, 7.952f, 2.125f, 7.906f, 2.193f)
                curveTo(7.87f, 2.247f, 7.855f, 2.265f, 7.845f, 2.27f)
                lineTo(7.843f, 2.271f)
                curveTo(7.841f, 2.272f, 7.838f, 2.271f, 7.811f, 2.266f)
                lineTo(7.795f, 2.263f)
                curveTo(7.787f, 2.262f, 7.779f, 2.261f, 7.772f, 2.26f)
                curveTo(7.657f, 2.244f, 7.629f, 2.288f, 7.629f, 2.462f)
                verticalLineTo(2.702f)
                curveTo(7.629f, 2.73f, 7.622f, 2.758f, 7.608f, 2.793f)
                curveTo(7.601f, 2.811f, 7.598f, 2.817f, 7.576f, 2.864f)
                curveTo(7.533f, 2.954f, 7.516f, 3.006f, 7.516f, 3.074f)
                curveTo(7.516f, 3.131f, 7.523f, 3.169f, 7.54f, 3.211f)
                curveTo(7.543f, 3.218f, 7.552f, 3.239f, 7.561f, 3.258f)
                lineTo(7.561f, 3.258f)
                curveTo(7.569f, 3.276f, 7.576f, 3.293f, 7.58f, 3.301f)
                curveTo(7.598f, 3.344f, 7.614f, 3.392f, 7.63f, 3.453f)
                curveTo(7.655f, 3.55f, 7.682f, 3.587f, 7.74f, 3.622f)
                curveTo(7.816f, 3.669f, 7.848f, 3.706f, 7.903f, 3.853f)
                curveTo(7.932f, 3.93f, 7.949f, 3.983f, 7.958f, 4.017f)
                curveTo(7.96f, 4.024f, 7.961f, 4.029f, 7.962f, 4.034f)
                curveTo(7.953f, 4.041f, 7.954f, 4.046f, 7.957f, 4.06f)
                curveTo(7.959f, 4.065f, 7.96f, 4.066f, 7.961f, 4.067f)
                lineTo(7.962f, 4.069f)
                lineTo(7.962f, 4.069f)
                curveTo(7.965f, 4.074f, 7.965f, 4.074f, 7.97f, 4.077f)
                curveTo(7.971f, 4.078f, 7.973f, 4.08f, 7.975f, 4.081f)
                curveTo(7.974f, 4.08f, 7.973f, 4.08f, 7.972f, 4.079f)
                curveTo(7.976f, 4.084f, 7.981f, 4.09f, 7.987f, 4.098f)
                curveTo(8.046f, 4.175f, 8.12f, 4.175f, 8.192f, 4.1f)
                lineTo(8.149f, 4.056f)
                curveTo(8.102f, 4.105f, 8.07f, 4.105f, 8.034f, 4.059f)
                lineTo(8.023f, 4.044f)
                close()
                moveTo(8.749f, 2.209f)
                lineTo(8.748f, 2.208f)
                lineTo(8.749f, 2.209f)
                lineTo(8.749f, 2.209f)
                close()
            }
            path(fill = SolidColor(Color(0xFF272727))) {
                moveTo(8.609f, 11.178f)
                lineTo(8.647f, 10.868f)
                curveTo(9.318f, 10.95f, 9.767f, 10.991f, 9.993f, 10.991f)
                curveTo(10.333f, 11.007f, 10.74f, 10.982f, 11.21f, 10.917f)
                lineTo(11.253f, 11.227f)
                curveTo(10.765f, 11.294f, 10.34f, 11.32f, 9.986f, 11.304f)
                curveTo(9.75f, 11.304f, 9.293f, 11.262f, 8.609f, 11.178f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun SanMarinoPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.SanMarino,
            contentDescription = "San Marino Flag"
        )
    }
}
